import { render, staticRenderFns } from "./pagination.vue?vue&type=template&id=09327f5e&"
import script from "./pagination.vue?vue&type=script&lang=js&"
export * from "./pagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09327f5e')) {
      api.createRecord('09327f5e', component.options)
    } else {
      api.reload('09327f5e', component.options)
    }
    module.hot.accept("./pagination.vue?vue&type=template&id=09327f5e&", function () {
      api.rerender('09327f5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/pagination.vue"
export default component.exports